export enum LtlLoaders {
  "FETCHING_LTL_QUOTES" = "FETCHING_LTL_QUOTES",
  "CHECKING_QUOTE_PURCHASE_STATUS" = "CHECKING_QUOTE_PURCHASE_STATUS",
  "FETCHING_BOL" = "FETCHING_BOL",
}
